<template>
  <div class="pay">
    <van-tabs class="c-tab" v-model="tabActive" sticky :before-change="beforeChange">
      <van-tab v-for="(item, index) in tabList" :key="index" :title="item">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            v-if="list"
          >
            <div
              class="message-item van-hairline--top-bottom"
              v-for="(message, messageIndex) in list"
              :key="messageIndex"
            
            >
              <div class="message-item-user">
                <!-- <img
              class="message-item-user__img"
              src="https://user-gold-cdn.xitu.io/2020/1/9/16f896e086199562?imageView2/1/w/180/h/180/q/85/format/webp/interlace/1"
            /> -->
                <div style="display:flex;align-items: center;">
                  <span
                    v-if="message.state == '0'"
                    class="state"
                    style="background: red;
                    display: block;
                    width: 8px;
                    height: 8px;
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    border-radius: 50%;"
                  ></span>
                  <i v-if="index == 0" class="borderIcon borderIcon1 iconfont icon-tongzhi2"></i>
                  <svg
                    v-if="index == 1"
                    class="borderIcon borderIcon2 icon closeImg"
                    aria-hidden="true"
                    style="width: 18px;height: 18px;"
                  >
                    <use xlink:href="#icon-xianshangzuoye"></use>
                  </svg>
                  <svg
                    v-if="index == 2"
                    class="borderIcon borderIcon3 icon closeImg"
                    aria-hidden="true"
                    style="width: 18px;height: 18px;"
                  >
                    <use xlink:href="#icon-icon-ml"></use>
                  </svg>
                  <ul class="message-item-user__right">
                    <!-- <li v-if="index == 0">{{ message.Msgtitle }}</li> -->
                    <li >{{ message.Msgtitle }}</li>
                    <!-- <li v-if="index == 2"></li> -->
                    <li>
                      <span class="message-item-user__right__date">{{ message.Createtime }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <p class="message-item-content van-multi-ellipsis--l2">
                {{ message.Msgcontent }}
                {{ message.msg }}
              </p>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Stomp from 'stompjs'
import { List, PullRefresh, Tabs, Tab ,Toast} from 'vant'

export default {
  data() {
    return {
      tabActive: 0,
      refreshing: false,
      list: [],
      pageNo: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      studentInfo:{},
      tabList: ['学校通知', '家庭作业']
    }
  },
  mounted() {
    
    // this.getSchoolNoticeList()
    // this.getWorkList()
    var sinfo = localStorage.getItem("currentChild");
        this.studentInfo = JSON.parse(sinfo);
        if(this.studentInfo.Studentid==""){
          Toast("未选定孩子")
          this.$router.push("/my");
          return;
        }
   
  },
  methods: {


    onRefresh() {
      // 清空列表数据
      this.finished = false
      this.pageNo = 1
      this.list = []

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.refreshing = true
      this.onLoad()
    },

    onLoad() {
      this.getList()
      this.pageNo++
    },

    // 获取作业列表
    getList() {
      
      var api = null
      if (this.tabActive == '0') {
        api = this.$api.msg.getschoolmsg
        this.$http
          .json_post(api, {
            Studentid: eval(this.studentInfo.Studentid),
            pageNo: this.pageNo,
            pageSize: this.pageSize
          })
          .then(data => {
            if (data.code == 0) {
              const res = data.data
              
              if (res.length === 0) {
                //this.list = []
                this.finished = true
              }
              
              this.list.push(...res)
              this.loading = false
              this.refreshing = false
           
            }else {
              Toast(data.msg)
            }
          })
      } else if (this.tabActive == '1') {
        api = this.$api.msg.gethomeworkmsg
        this.$http
          .json_post(api, {
            Studentid: eval(this.studentInfo.Studentid),
            pageNo: this.pageNo,
            pageSize: this.pageSize
          })
          .then(data => {
            if (data.code == 0) {
              const res = data.data
             
              if (res.length === 0) {
                //this.list = []
                this.finished = true
              }
           
              this.list.push(...res)
              this.loading = false
              this.refreshing = false
              
            }else {
              Toast(data.msg)
            }
          })
      } else if (this.tabActive == '2') {
        api = this.$api.msg.getdevicemsg
        this.$http
          .json_post(api, {
            Deviceid: this.studentInfo.Deviceid,
            // student_id: 10000059,
            sortField: 'id',
            sortType: 'desc',
            pageNo: this.pageNo,
            pageSize: this.pageSize
          })
          .then(data => {
            if (data.code ==0) {
              const res = data.data
              
              if (res.length === 0) {
                //this.list = []
                this.finished = true
              }
              
              this.list.push(...res)
              this.loading = false
              this.refreshing = false
             
            }else {
              Toast(data.msg)
            }
          })
      }
    },
    beforeChange(index) {
      this.tabActive = index
      this.pageNo = 1
      this.list = []
      this.onLoad()
      return true
    }
  },
  components: {
    'van-list': List,
    'van-pull-refresh': PullRefresh,
    'van-tab': Tab,
    'van-tabs': Tabs
  }
}
</script>

<style lang="scss" scoped>
.pay {
  height: 100%;
  .borderIcon {
    margin-right: 10px;
    border: 1px solid yellow;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
  }
  .borderIcon1 {
    font-size: 17px !important;
    border: 1px solid $primary-color;
  }
  .borderIcon2 {
    border: 1px solid #d5ac86;
  }
  .borderIcon3 {
    border: 1px solid #20c997;
  }
}

.message-item {
  margin-top: $space;
  padding: 16px;
  background: $background-color;
  &:last-of-type {
    margin-bottom: 60px;
  }
  .message-item-user {
    display: flex;
    align-items: center;
    .message-item-user__img {
      width: 30px;
      border-radius: 50%;
    }
    .iconfont {
      color: $primary-color;
      padding-right: 5px;
      font-weight: 400;
      font-size: 24px;
    }
    .message-item-user__right {
      // padding-left: 10px;

      .message-item-user__right__date {
        padding-top: 5px;
        color: $text-secondary-color;
        font-size: 12px;
      }
    }
  }
  .message-item-content {
    color: #999;
    padding-top: 10px;
    line-height: 20px;
  }
}
</style>
